import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { uniqueId } from 'lodash-es';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { translate } from '../../Services/translation';
import { addOverlay, removeOverlay } from '../../Actions/Overlay.action';
import { toggleInputActive } from '../../Actions/QuickSearch.action';
import clsx from 'clsx';

const StickyStoreNavigation = () => {
  const { storeScreen } = useTypedSelector<any>(
    (state) => state.navigation
  );
  const quickSearch = useTypedSelector((state) => state.quickSearch);
  const { inputActive } = quickSearch;
  const dispatch = useDispatch();
  const [id] = useState(uniqueId());

  useEffect(() => {
    if (inputActive) {
      dispatch(
        addOverlay('quick-search__' + id, () =>
          dispatch(toggleInputActive(false))
        )
      );
    } else {
      dispatch(removeOverlay('quick-search__' + id));
    }
  }, [dispatch, inputActive, id]);

  return (
    <div className="fixed bottom-0 z-30 w-full bg-gray-500">
      <ul className="grid grid-cols-5 gap-px">
        <li>
          <a
            className={clsx(
              storeScreen.startPageLink?.attributes?.active
                ? 'bg-gray-700'
                : 'bg-gray-900',
              'flex h-28 w-full items-center justify-center text-center text-md font-normal uppercase tracking-[0.16em] text-white'
            )}
            href={storeScreen.startPageLink?.href}
          >
            {storeScreen.startPageLink?.text}
          </a>
        </li>
        {storeScreen.links.map((link: any) => (
          <li key={link.href + link.text}>
            <a
              className={clsx(
                link.attributes?.active ? 'bg-gray-700' : 'bg-gray-900',
                'flex h-28 w-full items-center justify-center text-center text-md font-normal uppercase tracking-[0.16em] text-white'
              )}
              href={link.href}
            >
              {link.text}
            </a>
          </li>
        ))}
        <li>
          <button
            onClick={() =>
              dispatch(toggleInputActive(!inputActive, inputActive))
            }
            className={clsx(
              'flex h-28 w-full items-center justify-center bg-gray-900 text-center text-md font-normal uppercase tracking-[0.16em] text-white'
            )}
          >
            {translate('general.search')}
          </button>
        </li>
        <li>
          <a
            className={clsx(
              storeScreen.wallpaperCalculatorLink?.attributes?.active
                ? 'bg-gray-700'
                : 'bg-gray-900',
              'flex h-28 w-full items-center justify-center text-center text-md font-normal uppercase tracking-[0.16em] text-white'
            )}
            href={storeScreen.wallpaperCalculatorLink?.href}
          >
            {storeScreen.wallpaperCalculatorLink?.text}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default StickyStoreNavigation;
